import { render, staticRenderFns } from "./ActionsButtonsForms.vue?vue&type=template&id=6d6c17f6&scoped=true&"
import script from "./ActionsButtonsForms.vue?vue&type=script&lang=js&"
export * from "./ActionsButtonsForms.vue?vue&type=script&lang=js&"
import style0 from "./ActionsButtonsForms.vue?vue&type=style&index=0&id=6d6c17f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6c17f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VDivider,VExpandTransition})
